export default __webpack_public_path__ + "static/media/animal-25.f89249c7.svg";